<template>
    <div class="home-links-wrapper">
        <div class="home-links">
            <b-container class="home-links-container">
                <span class="home-links-container__title">
                    Quick Links
                </span>
                <ul class="home-links-container__links">
                    <li>
                        <a class="links" @click="openStyleGuide(styleGuides.CUSTOMER_DRIVE_INNOVATION_GUIDE)" href="javascript:void(0)">
                            Customer Driven Innovation(CDI) Guide</a>
                    </li>
                    <li>
                        <a class="links" @click="openStyleGuide(styleGuides.DEEP_CUSTOMER_EMPATHY_GUIDE)" href="javascript:void(0)">
                            Deep Customer Empathy Guide</a>
                    </li>
                    <li>
                        <a class="links"  @click="openStyleGuide(styleGuides.FOLLOW_ME_HOME_GUIDE)" href="javascript:void(0)">
                            Follow Me Home Guide</a>
                    </li>
                    <li>
                        <a class="links"  href="javascript:void(0)" @click="openStyleGuide(styleGuides.CUSTOMER_INTERVIEW_GUIDE)">
                            Customer Interview guide
                        </a>
                    </li>
                    <li>
                        <a  class="links" @click="openStyleGuide(styleGuides.INTERVIEW_QUESTION_GUIDE)" href="javascript:void(0)">
                            Interview Question Guide
                        </a>
                    </li>

                    <li>
                        <a class="links"  @click="openStyleGuide(styleGuides.CUSTOMER_PROBLEM_STATEMENT_GUIDE)" href="javascript:void(0)">
                            Customer Problem Statement Guide
                        </a>
                    </li>
                    <li>
                        <a class="links"  @click="openStyleGuide(styleGuides.IDEAL_STATE)" href="javascript:void(0)">
                            Ideal State Guide
                        </a>
                    </li>
                    <li>
                        <a class="links"  @click="openStyleGuide(styleGuides.GO_BROAD_TO_GO_NARROW)" href="javascript:void(0)">
                            Go Broad to Go Narrow Guide
                        </a>
                    </li>
                    <li>
                        <a class="links"  @click="openStyleGuide(styleGuides.BRAINSTORMING)" href="javascript:void(0)">
                            Brainstorming Guide
                        </a>
                    </li>
                    <li>
                        <a class="links"  @click="openStyleGuide(styleGuides.POINTS_NARROWING)" href="javascript:void(0)">
                            100 Points Guide
                        </a>
                    </li>
                    <li>
                        <a class="links"  @click="openStyleGuide(styleGuides.NARROWING)" href="javascript:void(0)">
                            2-by-2 Guide
                        </a>
                    </li>
                    <li>
                        <a class="links"  @click="openStyleGuide(styleGuides.SKETCH_PROTOTYPE)" href="javascript:void(0)">
                            Sketch Prototype Guide
                        </a>
                    </li>
                    <li>
                        <a class="links"  @click="openStyleGuide(styleGuides.RAPID_EXPERIMENTS)" href="javascript:void(0)">
                            Rapid Experiments with Customers Guide
                        </a>
                    </li>
                    <li>
                        <a class="links"  @click="openStyleGuide(styleGuides.LEAP_FAITH_ASSUMPTIONS)" href="javascript:void(0)">
                            Leap of Faith Assumptions Guide
                        </a>
                    </li>
                    <li>
                        <a class="links"  @click="openStyleGuide(styleGuides.TYPES_EXPERIMENTS)" href="javascript:void(0)">
                            Experiments Guide
                        </a>
                    </li>
                    <li>
                        <a class="links"  @click="openStyleGuide(styleGuides.TEST_HYPOTHESIS_TEST_PLAN)" href="javascript:void(0)">
                            Hypothesis Guide
                        </a>
                    </li>
                </ul>
                <div class="home-links-buttons">
                    <b-button v-if="isJACareerApp" class="btn-start" tabindex="0" block variant="primary" :to="{name: 'js_start_project'}">Start a New Career Plan</b-button>
                    <b-button v-if="isJAEntrepreApp" class="btn-start" tabindex="0" block variant="primary" :to="{name: 'be_start_project'}">Start a New Project</b-button>
                    <b-button class="btn-home" tabindex="0" block variant="outline-primary" :to="{ name: 'Activities' }">Home</b-button>
                    <b-button class="btn-return" tabindex="0" block variant="outline-primary" :to="{ name: 'Projects' }">Return to My Plan</b-button>
                </div>
            </b-container>
        </div>
        <project-style-guide :style-guide="styleGuide"/>
    </div>
</template>

<script>
    import StyleGuides from '../../../core/Utils/style-guides';
    import ProjectStyleGuide from "../../../core/Components/ProjectStyleGuide";

    export default {
        name: "HomeQuickLinks",
         components: {
            ProjectStyleGuide
        },
        data() {
            return {
                styleGuides: StyleGuides,
                styleGuide: {}
            }
        },
        methods: {
            openStyleGuide(currentStyleGuide) {
                if(currentStyleGuide){
                    this.styleGuide = this.styleGuides.getStyleGuide(currentStyleGuide);
                    this.$bvModal.show('project-style-guide')
                }
            },
        }
    }

</script>

<style scoped lang="stylus">
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"

    .home-links-wrapper
        background-color color-1

        .home-links
            padding-bottom 3rem
            padding-top 20px

            &-container
                box-shadow(0px 1px 5px color-shadow)
                padding 25px 20px 30px 25px
                border-radius 25px
                background-color color-blank
                margin-top 0px
                width 90%
                max-width none !important

                &__title
                    font font-poppins-semibold
                    font-size 16px
                    color color-dark

                &__links
                    margin-top 20px
                    display grid
                    grid-template-columns 1fr

                    .links
                        font font-sourcesans-regular
                        font-size 16px
                        color color-green-light

            &-buttons
                display flex
                align-items center
                margin-top 50px
                flex-direction column
                row-gap 20px

                .btn
                    width 260px
                    margin 0px auto
                    border 2px solid color-green-light
                    padding 12px 0

                .btn-start
                    background-color color-green-light
                    &:hover
                        background-color color-green-dark
                        border 2px solid color-green-dark

                .btn-home
                .btn-return
                    color color-green-light
                    font font-poppins-semibold
                    font-size 16px
                    &:hover
                        background-color color-green-dark !important
                        color color-blank

    @media (min-width: 768px) and (max-width: 1200px)
        .home-links
            padding-top 30px !important

            &-container
                width 90% !important

                &__links
                    grid-template-columns 1fr 1fr !important
                    grid-gap 15px 30px

            &-buttons
                flex-direction row !important
                column-gap 20px

                .btn-start
                    width 320px !important

                .btn-home
                .btn-return
                    width 250px !important

    @media (min-width: 1200px)
        .home-links-wrapper
            background-color color-blank !important

            .home-links
                padding-top 36px !important

                &-container
                    padding 50px 50px 51px 50px !important
                    width 65%

                    &__title
                        font-size 22px !important

                    &__links
                        grid-template-columns 1fr 1fr 1fr !important
                        grid-gap 15px 30px

                         .links
                            font-size 18px !important

                &-buttons
                    flex-direction row !important
                    column-gap 20px

                    .btn
                        width 320px !important
                        height 50px !important

</style>
